import { useEffect } from "react";
import { useWebSocket } from "../Context/WebSocketContext";
import WebsocketActions from "../Helper/WebsocketActions";

// Get Synced Data from Server after Server Update via WebSocket
export const WebSocketRoute = ({ children }) => {
    const { subscribe, isOnline } = useWebSocket();
    const { 
        handleOrderUpdate, 
        handleProductUpdate, 
        handleExtraUpdate, 
        handleCategoryUpdate, 
        handleDiscountUpdate, 
        handleOfferUpdate, 
        handleWorkspaceUpdate, 
        handleRegisterEntrieeUpdate, 
        handleWSUserUpdate ,
        handleTimeTrackingUpdate
    } = WebsocketActions();

    useEffect(() => {
        if (!isOnline) return;

        // SUBSCRIPTIONS AND DATA HANDLER
        const unsubOrders = subscribe("orders", (msg) => {
            handleOrderUpdate();
        });

        const unsubProducts = subscribe("products", (msg) => {
            handleProductUpdate();
        });

        const unsubExtras = subscribe("extras", (msg) => {
            handleExtraUpdate();
        });

        const unsubCategories = subscribe("categories", (msg) => {
            handleCategoryUpdate();
        });

        const unsubDiscounts = subscribe("discounts", (msg) => {
            handleDiscountUpdate();
        });

        const unsubOffers = subscribe("offers", (msg) =>{
            handleOfferUpdate()
        })

        const unsubWS = subscribe("ws", (msg) =>{
            handleWorkspaceUpdate()
        })

        const unsubRegisterEntries = subscribe("cash_register", (msg) => {
            handleRegisterEntrieeUpdate();
        })

        const unsubWSUser = subscribe("ws_user", (msg) => {
            handleWSUserUpdate();
        })

        const unsubTimeTracking = subscribe("time_trackings", (msg) => {
            handleTimeTrackingUpdate();
        })

        // cleanup beim route leave
        return () => {
            console.log("🔴 WebSocketRoute cleanup");
            unsubWS?.();
            unsubOrders?.();
            unsubProducts?.();
            unsubExtras?.();
            unsubCategories?.();
            unsubDiscounts?.();
            unsubOffers?.();
            unsubRegisterEntries?.();
            unsubWSUser?.();
            unsubTimeTracking?.();
        };
    }, [isOnline]);

    return children;
};